import React, { useEffect, useState } from 'react'
import makeStyles from "@mui/styles/makeStyles"
import { Box, Stack, Paper, Grid, Typography, styled, IconButton, Tooltip, LinearProgress } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { Container } from '@mui/material'
import format from "date-fns/format"
import EventAlert from '../components/EventAlert'
import EventMobileItem from '../components/EventMobileItem'
import { Warning } from "@mui/icons-material"
import RefreshIcon from '@mui/icons-material/Refresh'

const useStyles = makeStyles((theme) => {
    return {
        pageEvent: {
            marginBottom: "35px"
        },
        pageEventGrid: {
            width: "calc(100% + 48px) !important"
        },
        stack: {
            maxWidth: "100%"
        },
        eventPageHeader: {
            height: "100%",
            alignItems: 'center',
            [theme.breakpoints.up('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"eventPageItem1 eventPageItem2 eventPageItem3 eventPageItem4 eventPageItem5 eventPageItem6"`,
            },
            [theme.breakpoints.down('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"eventPageItem1 eventPageItem2 eventPageItem3 eventPageItem3" 
                "eventPageItem4 eventPageItem5 eventPageItem6 eventPageItem6"`,
            }
        },
        eventPageItem1: {
            gridArea: "eventPageItem1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        eventPageItem2: {
            gridArea: "eventPageItem2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        eventPageItem3: {
            gridArea: "eventPageItem3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        eventPageItem4: {
            gridArea: "eventPageItem4",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        eventPageItem5: {
            gridArea: "eventPageItem5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        eventPageItem6: {
            gridArea: "eventPageItem6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }
});

const EventDesktopContainer = styled(Container)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        display: 'none'
    },
    [theme.breakpoints.down('xl')]: {
        "max-width": "1090px"
    },
    [theme.breakpoints.down('lg')]: {
        "max-width": "820px"
    },
    [theme.breakpoints.down('md')]: {
        "max-width": "660px"
    },
}))

const EventMobileContainer = styled(Container)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        display: 'none'
    }
}))

const Item = styled(Paper)(({ theme, eventcolor }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: '100%',
    borderRadius: '20px',
    border: '3px solid #E0E0E0',
    borderLeft: '3px solid #7F8C8D',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    marginTop: 6,
    '&:hover': {
        transform: 'translateY(-3px)',
        borderLeft: `3px solid ${eventcolor || '#E74C3C'}`,
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)'
    }
}));

const ItemHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: '#34495E',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: '#ECF0F1',
    height: '56px',
    width: '100%',
    borderRadius: '20px 20px 0 0',
    borderBottom: '3px solid #E74C3C',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #34495E 0%, #2C3E50 100%)'
}));

const ReceiveData = (props) => {
    const history = useHistory()
    const classes = useStyles(props)
    const [rows, setRows] = useState([])
    const [serialKey, setSerialKey] = useState()
    const [eventDate, setEventDate] = useState("")
    const [isLoading, setIsLoading] = useState(false);

    const handleDate = (date) => {
        var date = format(new Date(date), 'dd/MM/yyyy HH:mm')
        return date
    }

    const getEventColor = (row) => {
        if (row.dS_DESCRICAO_EVENTO === "Sub Central") {
            if (row.fK_OCORRENCIA === "ALARME DE RETORNO" ||
                row.fK_OCORRENCIA === "ALARME EXTRA" ||
                row.fK_OCORRENCIA === "ALARME VISUAL") {
                return "#FFEA00"
            }
            if (row.fK_OCORRENCIA === "SISTEMA RESTAURADO") {
                return "#00B33C";
            }
            if (row.fK_OCORRENCIA === "ALARME DE BRIGADA") {
                return "#F58634";
            }
            if (row.fK_OCORRENCIA === "ALARME DE ABANDONO") {
                return "#CA373C";
            }
        }
        if (row.fK_OCORRENCIA === "BATERIA BAIXA" ||
            row.fK_OCORRENCIA === "SINALIZAÇAO VISUAL ATIVA" ||
            row.fK_OCORRENCIA === "REMOVIDO" ||
            row.fK_OCORRENCIA === "SILENCIAR ALARME" ||
            row.fK_OCORRENCIA === "CONTROLE AMBIENTAL" ||
            row.fK_OCORRENCIA === "SEM REDE AC"
        ) {
            return "#FFEA00"
        } else {
            return "#CA373C"
        }
    }

    const populateData = () => {
        setIsLoading(true);

        fetch(`${process.env.REACT_APP_URL}/UserFetchData/remote?serialKey=${props.systemData.serialKeys}`, {
            method: 'GET',
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            }
        })
        .then(response => response.json())
        .then(data => {
            setRows(data);
            setIsLoading(false);
        });
    }

    useEffect(() => {
        populateData()
    }, []);

    useEffect(() => {
        //setIsLoading(true);

        setRows((currentRows) => [...currentRows, props.streaming])
        if (rows.length > 99) 
        {
            rows.shift()
        }
        setSerialKey(props.systemData.serialKeys);
        //setIsLoading(false);
    }, [props.streaming])

    return (
        
        <div style={{opacity: 1, backgroundColor: 'transparent', paddingTop: '1.5rem', paddingBottom: '2rem'}}>
            {isLoading && 
                <LinearProgress color="secondary" style={{position: "fixed", top: "0px", left: "0", width: "100%", zIndex: "1201"}} /> 
            }

            <EventDesktopContainer className={classes.pageEvent}>
                <Box sx={{ 
                    bgcolor: 'transparent',
                    borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                    borderRadius: '0',
                    padding: '8px 0',
                    marginBottom: '1rem',
                    boxShadow: 'none',
                    textAlign: 'center',
                    cursor: 'default',
                    pointerEvents: 'none',
                    userSelect: 'none'
                }}>
                    <Typography 
                        variant="h5" 
                        component="h3" 
                        sx={{ 
                            fontWeight: 400,
                            color: 'text.secondary',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                            fontSize: '0.95rem'
                        }}
                    >
                        Eventos dos Equipamentos - Hoje ({new Date().toLocaleDateString()})
                    </Typography>
                </Box>

                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mb: 3,
                    flexWrap: 'wrap',
                    gap: 2
                }}>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Recarregar Eventos">
                            <IconButton 
                                onClick={() => populateData()}
                                disabled={isLoading}
                                sx={{
                                    bgcolor: 'rgba(52, 152, 219, 0.2)',
                                    border: '2px solid #3498DB',
                                    '&:hover': { bgcolor: 'rgba(52, 152, 219, 0.4)' }
                                }}
                            >
                                <RefreshIcon/>
                            </IconButton>
                        </Tooltip>
                    </Box>

                    <Box sx={{ 
                        bgcolor: 'rgba(255, 255, 255, 0.05)',
                        border: '3px solid #E0E0E0',
                        borderRadius: '20px',
                        padding: '12px 24px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        marginLeft: 'auto'
                    }}>
                        <Typography variant="h6" color="textPrimary">
                            Eventos Encontrados: <strong>{rows.filter(row => row && row.fK_CENTRAL === serialKey && row.type !== "alarme").length}</strong>
                        </Typography>
                    </Box>
                </Box>

                <Stack className={classes.stack} alignItems="center" spacing={2} marginTop={1}>
                        <ItemHeader key={0} xs={12} md={6} lg={4}>
                            <Box className={classes.eventPageHeader}>
                                <Box className={classes.eventPageItem1}><Warning /></Box>
                                <Box className={classes.eventPageItem2}><Typography variant="delta">Ocorrência</Typography></Box>
                                <Box className={classes.eventPageItem3}><Typography variant="delta">Descrição</Typography></Box>
                                <Box className={classes.eventPageItem4}><Typography variant="delta">I.D.</Typography></Box>
                                <Box className={classes.eventPageItem5}><Typography variant="delta">Local</Typography></Box>
                                <Box className={classes.eventPageItem6}><Typography variant="delta">Data</Typography></Box>
                            </Box>
                        </ItemHeader>
                        {rows.length > 0
                        ?
                        <>
                        {
                            rows.slice(0).reverse().map(row => {
                                if (row) {
                                    return row.fK_CENTRAL === serialKey ? row.type === "alarme"
                                        ?
                                        null
                                        :
                                        <Item key={row.id} xs={12} md={6} lg={4} eventcolor={getEventColor(row)}>
                                            <EventAlert key={row.id} row={row} />
                                        </Item>
                                        : null
                                }
                            })
                        }
                        </>
                        :
                        <Box key={1} xs={12} md={12} lg={12}>
                            <center>
                                <h4>Sem Eventos Registrados na Data de Hoje!</h4>
                            </center>
                        </Box>
                        }
                    </Stack>
            </EventDesktopContainer>

            <EventMobileContainer className={classes.pageEvent}>
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-start',
                    mb: 2
                }}>
                    <Tooltip title="Recarregar Eventos">
                        <IconButton 
                            onClick={() => populateData()}
                            sx={{
                                bgcolor: 'rgba(52, 152, 219, 0.2)',
                                border: '2px solid #3498DB',
                                '&:hover': { bgcolor: 'rgba(52, 152, 219, 0.4)' }
                            }}
                        >
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Grid alignItems="center" container spacing={3} className={classes.pageEventGrid}>
                {rows.length > 0
                ?
                <>
                    {rows.slice(0).reverse().map(row => {
                        if (row) {
                            return row.fK_CENTRAL === serialKey ? row.type === "alarme"
                                ?
                                null
                                :
                                <Grid item key={row.id} xs={12} md={12} lg={12}>
                                    <EventMobileItem row={row} />
                                </Grid>
                                : null
                        }
                    })}
                </>
                        :
                <Grid key={1} xs={12} md={12} lg={12}>
                    <center>
                        <h4>Sem Eventos Registrados na Data de Hoje!</h4>
                    </center>
                </Grid>
                }
                </Grid>
            </EventMobileContainer>
        </div>
    );
}

export default ReceiveData;